import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyOpenOrders } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./AllOpenOrdersPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const AllOpenOrdersPage = () => {
  const [orders] = useState(dummyOpenOrders);
  const [search, setSearch] = useState("");

  const filtered = orders.filter(
    (o) =>
      o._id?.toLowerCase().includes(search.toLowerCase()) ||
      o.user_email?.toLowerCase().includes(search.toLowerCase()) ||
      `${o.pay_currency}/${o.ask_currency}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>All Open Orders</span>
          </p>
          <h1 className="dashboard-hero__title">All Open Orders</h1>
          <p className="dashboard-hero__subtitle">
            View and manage all open orders
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-list" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="openorders-section">
          <div className="openorders-section__header">
            <div className="openorders-section__title-wrap">
              <span className="openorders-section__icon">
                <i className="fas fa-clipboard-list" />
              </span>
              <h2 className="openorders-section__title">Open Orders</h2>
            </div>
            <div className="openorders-section__stats">
              <span className="openorders-stat">
                <strong>{orders.length}</strong> Open
              </span>
            </div>
          </div>
          <div className="openorders-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by order ID, email or pair..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="openorders-search-input"
            />
          </div>
          <div className="openorders-table-wrap">
            <table className="openorders-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Updated</th>
                  <th>User ID</th>
                  <th>User Email</th>
                  <th>Mobile</th>
                  <th>Pair</th>
                  <th>Side</th>
                  <th>Order Type</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Filled</th>
                  <th>Remaining</th>
                  <th>Maker Fee</th>
                  <th>Taker Fee</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row._id}>
                    <td><span className="openorders-order-id">{row._id}</span></td>
                    <td>{formatDate(row.updatedAt)}</td>
                    <td>{row.user_id}</td>
                    <td>{row.user_email}</td>
                    <td>{row.user_mobileNumber}</td>
                    <td><strong>{row.pay_currency}/{row.ask_currency}</strong></td>
                    <td>
                      <span className={`openorders-side openorders-side--${row.side?.toLowerCase()}`}>
                        {row.side}
                      </span>
                    </td>
                    <td>{row.order_type}</td>
                    <td>{typeof row.price === "number" ? row.price.toLocaleString("en-IN", { minimumFractionDigits: 2 }) : row.price}</td>
                    <td>{typeof row.quantity === "number" ? row.quantity.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.quantity}</td>
                    <td>{typeof row.filled === "number" ? row.filled.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.filled}</td>
                    <td>{typeof row.remaining === "number" ? row.remaining.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.remaining}</td>
                    <td>{typeof row.maker_fee === "number" ? row.maker_fee.toLocaleString("en-IN", { minimumFractionDigits: 5 }) : row.maker_fee}</td>
                    <td>{typeof row.taker_fee === "number" ? row.taker_fee.toLocaleString("en-IN", { minimumFractionDigits: 5 }) : row.taker_fee}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="openorders-empty">No open orders match your search.</p>
          )}
        </section>
      </div>
    </main>
  );
};

export default AllOpenOrdersPage;
